@use '@hevoio/hevo-ui-toolkit/styles/typography/typography-utils' as typography;
@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.wrapper {
  display: block;
}

.wrapper:hover {
  &::before {
    position: absolute;
    left: 0;
    right: 0;
    content: '';
    height: 28px;
    background-color:  hevo-toolkit-variables.$ripple-bg;
    z-index: 0;
  }
}

.fileContainer {
  display: flex;
  align-items: center;
  flex-grow: 1;
  position: static;
  padding: 0  hevo-toolkit-variables.$spacer 0  hevo-toolkit-variables.$spacer * 2.3;
  height: 28px;
}

.fileContainer .left {
  flex: 3 1 0;
  display: flex;
  align-items: center;
  @include typography.typography-level-to-styles(typography.typography-config(), body-1);
  overflow: hidden;
  z-index: 1;
}

.fileName {
  text-overflow: ellipsis;
  overflow: hidden;
  @include typography.typography-level-to-styles(typography.typography-config(), body-2);
}

.fileType {
  color:  hevo-toolkit-variables.$text-secondary;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left:  hevo-toolkit-variables.$spacer * 0.25;
  white-space: nowrap;
}

.copySm {
  margin-left:  hevo-toolkit-variables.$spacer * 0.5;
  display: none;
  cursor: pointer;
}

.fileKeys {
  flex: 3 1 0;
  margin-right:  hevo-toolkit-variables.$spacer * 0.25;
  margin-left:  hevo-toolkit-variables.$spacer * 0.5;
  justify-content: flex-end;
  z-index: 1;
}

.fileContainer:hover {
  .copySm {
    display: flex;
  }
}

.searchHighlight {
  color:  hevo-toolkit-variables.$primary;
}
